import {takeLatest, all} from 'redux-saga/effects';
import types from '../../../../../../../actions/types';
import {handleFormSubmit} from '../../../../../../../sagas/common-sagas';

function* saveNew(action) {
    yield handleFormSubmit('/api/games/', action, types.SAVE_NEW_GAME);
}

export default function* sagas() {
    yield all([
        takeLatest(types.SAVE_NEW_GAME.REQUEST, saveNew)
    ]);
}



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/new/modules/game-new-sagas.js